import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import * as CertificationActions from './certification.actions';
import * as CertificationSelectors from './certification.selectors';

@Injectable({
  providedIn: 'root',
})
export class CertificationFacade {
  readonly certifications$ = this.store.pipe(
    select(CertificationSelectors.selectCertifications)
  );
  readonly certificationCount$ = this.store.pipe(
    select(CertificationSelectors.selectCertificationCount)
  );

  constructor(private store: Store<AppState>) {}

  loadCertifications() {
    this.store.dispatch(CertificationActions.loadCertifications());
  }

  clearCertifications() {
    this.store.dispatch(CertificationActions.clearCertifications());
  }
}
